"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostAgency = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const graphql_1 = require("../graphql");
const orm_1 = require("../orm");
let HostAgency = class HostAgency extends orm_1.CDBaseEntity {
    constructor() {
        super(...arguments);
        this.currency = legacy_enums_1.Currency.Dollar;
        this.partnerBookingAvailable = false;
        this.isCommissionHidden = false;
    }
};
exports.HostAgency = HostAgency;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDObjectIdColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((value) => {
        return typeof value === "string" ? value.trim() : value;
    }),
    __metadata("design:type", String)
], HostAgency.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], HostAgency.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], HostAgency.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/^[a-z0-9\-_]+$/, {
        message: "url should contain only lowercase alphanumeric characters",
    }),
    __metadata("design:type", String)
], HostAgency.prototype, "url", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(1),
    __metadata("design:type", Number)
], HostAgency.prototype, "discountCoefficient", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    __metadata("design:type", Number)
], HostAgency.prototype, "commissionPercentage", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], HostAgency.prototype, "partnerBookingAvailable", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], HostAgency.prototype, "defaultCountryIso", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], HostAgency.prototype, "ownerId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], HostAgency.prototype, "logoUrl", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(() => String, { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.HostAgencyType),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], HostAgency.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], HostAgency.prototype, "isCommissionHidden", void 0);
exports.HostAgency = HostAgency = __decorate([
    (0, graphql_1.GObjectType)("HostAgency"),
    (0, orm_1.CDEntity)("hostAgencies")
], HostAgency);
//# sourceMappingURL=HostAgency.js.map